import type { AppRoute } from "@/lib/routing";

// Owner: C6 (assistant and smart helpers). Path from spec §9.1.
export const routes: AppRoute[] = [
  {
    path: "/assistant",
    lazy: async () => ({ Component: (await import("./pages/AssistantPage")).AssistantPage }),
    handle: {
      title: "Assistant",
      keywords: ["substitutes", "IFRA auto-fix", "evaporation", "cheaper sources", "library", "chat", "AI"],
    },
  },
];
